import { reactive, ref, Ref } from "@vue/composition-api";
import { CWorkOrderTask } from "@/store/modules/workOrderTasks";
import { format } from "date-fns";

export const enum WorkOrderTaskStatus {
  pending = "pending",
  queued = "queued",
  completed = "completed",
}

const prettifiedWorkOrderTaskStatus = {
  pending: "Pending",
  queued: "Queued",
  completed: "Completed",
};

export const prettifyWorkOrderTaskStatus = (s: WorkOrderTaskStatus) => {
  return prettifiedWorkOrderTaskStatus[s];
};

export const workOrderTaskStatusReverseLookup = <
  { [key: string]: WorkOrderTaskStatus }
>{
  pending: WorkOrderTaskStatus.pending,
  queued: WorkOrderTaskStatus.queued,
  completed: WorkOrderTaskStatus.completed,
};

export function buildFormEditTask() {
  const editingTaskId = ref<string>("id");

  let editingTask = reactive<CWorkOrderTask>({
    id: "",
    name: "",
    description: "",
    start_date: "",
    completed_date: "",
    status: "",
    sort_order: 0,
    user_id: "",
    work_order_id: "",
    work_order_task_line_items: [],
  });

  const editTask = (
    fnMode: "complete" | "edit",
    editingTaskId: Ref<string>,
    editingTask: CWorkOrderTask,
    task: CWorkOrderTask,
  ) => {
    const td = format(new Date(), "yyyy-MM-dd");
    editingTaskId.value = task.id;
    editingTask.id = task.id;
    editingTask.name = task.name;
    editingTask.description = task.description;

    if (fnMode === "complete") {
      editingTask.status = "completed";
      editingTask.start_date = td;
      editingTask.completed_date = td;
    } else {
      editingTask.status = task.status;
      editingTask.start_date = task.start_date;
      editingTask.completed_date = task.completed_date;
    }

    editingTask.work_order_task_line_items = task.work_order_task_line_items;
  };

  const cancelEditTask = (editingTaskId: Ref<string>, task: CWorkOrderTask) => {
    if (editingTaskId.value === task.id) {
      editingTaskId.value = "";
    }
  };

  return {
    editTask,
    editingTask,
    editingTaskId,
    cancelEditTask,
  };
}
